import styled from 'styled-components';
import { SIZING, COLORS, Color } from '../../styles/variables';
import { device } from '../../styles/devices';

export const StatusContainer = styled.div`
  position: relative;
  margin-top: 0px;
  z-index: 2;
  @media ${device.tablet} {
    margin-top: ${SIZING.unit(4.25)};
  }
`;
export const StatusBlock = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StatusText = styled.p`
  margin: 0px 8.7px 0px 10.5px;
`;

export const Status = styled.div<{ backColor: Color; textColor: Color }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  line-height: 20px;
  background-color: ${({ backColor }) => backColor || COLORS.white};
  color: ${({ textColor }) => textColor || COLORS.grey60};
  letter-spacing: 0.002px;
  padding: ${SIZING.unit(0.5)} ${SIZING.unit(1.5)};
  width: max-content;
`;

export const StatusDot = styled.div<{ dotColor: Color }>`
  width: 8px;
  height: 8px;
  background: ${({ dotColor }) => dotColor || ''};
  border-radius: 50%;
  margin-right: ${SIZING.unit(1)};
`;

export const StatusTitle = styled.div``;

export const InfoIconWrapper = styled.div`
  height: 20px;
  width: 20px;
  margin-left: ${SIZING.unit(1)};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
